export default class SpecialSituationsCtrl {

	constructor ($scope, WorkPlanParametrizationSrv, $timeout, $stateParams, $mdDialog, $interval, $uiGridConstants, i18nService, GlobalSrv, GlobalConfig, $cookies, Validations) {
		// CONSTANTS
		const specialSituationVM = this
		const user = JSON.parse($cookies.get('currentUser'))
		const currentRoleId = JSON.parse($cookies.get('hasRoleId'))

		specialSituationVM.gridApi = {}
		specialSituationVM.teachers = {}
		specialSituationVM.list = {}
		specialSituationVM.submodules = {}
		specialSituationVM.workplan = {}
		specialSituationVM.specialSituations = 0
		specialSituationVM.situationsPercentage = 0
		i18nService.setCurrentLang('es')
		specialSituationVM.gridSpecialSituations = {
			enableFiltering          : true,
			enableRowSelection       : true,
			enableRowHeaderSelection : false,
			noUnselect               : true,
			multiSelect              : false,
			modifierKeysToMultiSelect: false,
			columnDefs               : [
				{
					name            : 'Nombre de profesor',
					displayName     : 'Nombre de profesor',
					field           : 'teacher_name',
					width           : '32%',
					headerCellClass : specialSituationVM.highlightFilteredHeader,
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : true,
					enableCellEdit  : true,
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs',
				},
				{
					name            : 'Tipo profesor',
					displayName     : 'Tipo profesor',
					field           : 'teacher_type',
					width           : '25%',
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : true,
					enableCellEdit  : true,
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs',
				},
				{
					name            : 'Estado del plan',
					displayName     : 'Estado del plan',
					field           : 'workplan_state',
					width           : '23%',
					SenableGridMenu : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : true,
					enableCellEdit  : true,
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs',
				},
				{
					name            : 'Acciones',
					displayName     : 'Acciones',
					field           : 'id_state',
					width           : '20%',
					enableGridMenu  : false,
					enableFiltering : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : true,
					cellClass       : 'column-center text-xs text-azul proxima',
					headerCellClass : 'column-center font-normal text-xs',
					cellTemplate    : require('./cellActionSpecialSituations.html'),
				},
			],
			selectedItem : [],
			onRegisterApi: (gridApi) => {
				specialSituationVM.gridApi = gridApi
				specialSituationVM.gridApi.grid.registerRowsProcessor(specialSituationVM.singleFilter, 200)
				$interval(() => {
					specialSituationVM.gridApi.core.handleWindowResize()
					specialSituationVM.gridApi.selection.selectRow(specialSituationVM.gridSpecialSituations.data[0])
				}, 500, 10)
			},
		}

		let iconClasses = [
			'mdi-hardware-keyboard-arrow-down',
			'mdi-hardware-keyboard-arrow-up',
		]

		// VARIABLES
		specialSituationVM.teachersFilter = ''
		specialSituationVM.class = iconClasses[0]
		specialSituationVM.dropdownMenu = false

		// METHODS
		specialSituationVM.toggleChevron = toggleChevron
		specialSituationVM.singleFilter = singleFilter
		specialSituationVM.highlightFilteredHeader = highlightFilteredHeader
		specialSituationVM.filter = filter
		specialSituationVM.updateView = updateView
		specialSituationVM.returnBack = returnBack

		// MODALS
		specialSituationVM.showAddSituationModal = showAddSituationModal
		specialSituationVM.showDetailsModal = showDetailsModal

		// METHODS DEFINITIONS
		function activate () {
			return getSpecialSituationData()
		}

		function getSpecialSituationData () {
			let header = { }

			if (Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId)) {
				header.userId = user.id
				header.rolId = currentRoleId
			}
 
			return WorkPlanParametrizationSrv.getSpecialSituationData.get(header).$promise.then((dataReturn) => {
				if (dataReturn.status === true) {
					specialSituationVM.teachers = dataReturn.teacher
					specialSituationVM.list = dataReturn.list
					specialSituationVM.submodules = dataReturn.submodules
					specialSituationVM.gridSpecialSituations.data = specialSituationVM.teachers
					specialSituationVM.teachers.forEach((teacher) => {
						if (teacher.id_state === 2) {
							++specialSituationVM.specialSituations
						}
					})
					specialSituationVM.situationsPercentage = (Math.round((specialSituationVM.specialSituations / specialSituationVM.teachers.length) * 100)).toString()
				} else {
					console.log('communications failure with server')
					specialSituationVM.teachers = []
					specialSituationVM.gridSpecialSituations.data = specialSituationVM.teachers
				}
			})
		}

		function getTeachersDetails (teacher) {
			let header = { idTeacher : teacher.id_teacher,
				idWorkplan: teacher.id_work_plan }

			return WorkPlanParametrizationSrv.getTeachersDetails.get(header).$promise.then((dataReturn) => {
				if (dataReturn.status === true) {
					$mdDialog.show({
						controller: [ '$scope', '$mdDialog', function ($scope, $mdDialog) {
							$scope.teacher = teacher
							$scope.info = dataReturn.data[0]
							$scope.startDate = moment($scope.info.dt_start_date, 'YYYY-MM-DD').toDate()
							$scope.endDate = moment($scope.info.dt_end_date, 'YYYY-MM-DD').toDate()
							$scope.items = $scope.info.submodule.split(',')
							$scope.validateDate = (date) => {
								return isNaN(date)
							}
							$scope.close = () => {
								$mdDialog.hide()
							}
						} ],
						template           : require('./detailsModal.html'),
						clickOutsideToClose: true,
					})
				}
			})
		}

		function returnBack () {
			window.history.back()
		}

		function toggleChevron () {
			if (specialSituationVM.class === iconClasses[0]) {
				specialSituationVM.class = iconClasses[1]
				specialSituationVM.dropdownMenu = true
			} else {
				specialSituationVM.class = iconClasses[0]
				specialSituationVM.dropdownMenu = false
			}
		}

		function highlightFilteredHeader (row, rowRenderIndex, col, colRenderIndex) {
			if (col.filters[0].term) {
				return 'header-filtered'
			} else {
				return ''
			}
		}

		function filter () {
			specialSituationVM.gridApi.grid.refresh()
		}

		function singleFilter (renderableRows) {
			var matcher = new RegExp(specialSituationVM.teachersFilter, 'i')

			renderableRows.forEach((row) => {
				var match = false;

				[ 'teacher_name', 'teacher_type', 'workplan_state' ].forEach((field) => {
					if (row.entity[field].match(matcher)) {
						match = true
					}
				})

				if (!match) {
					row.visible = false
				}
			})

			return renderableRows
		}

		function updateView () {
			specialSituationVM.viewLoaded = false
			$timeout(() => {
				specialSituationVM.viewLoaded = true
			}, 1)
		}

		// MODAL DEFINITIONS
		function showAddSituationModal (teacher) {
			let list = specialSituationVM.list
			let submodules = specialSituationVM.submodules
			let updateView = specialSituationVM.updateView
			let params = {
				workplanId: teacher.id_work_plan,
			}

			WorkPlanParametrizationSrv.getWorkPlanHeader.get(params).$promise.then((dataReturn) => {
				if (dataReturn.status == true) {
					specialSituationVM.workplan = dataReturn.data
				}

				let workplan = specialSituationVM.workplan

				$mdDialog.show({
					controller: [ '$scope', '$mdDialog', function ($scope, $mdDialog) {
						$scope.workplan = workplan
						$scope.teacher = teacher
						$scope.workplans = {}
						$scope.list = list
						$scope.items = submodules
						$scope.isDisabled = false
						$scope.addingEnabled = false
						$scope.selected = []
						$scope.submodules = []
						$scope.updateView = updateView
						$scope.startDate = null
						$scope.endDate = null
						$scope.details = ''
						$scope.situationData = ''
						$scope.validateForm = validateForm
						$scope.hasError = hasError
						$scope.showErrorMessages = showErrorMessages
						$scope.startDateChange = startDateChange
						$scope.minStartDate = new Date(workplan.start_date)
						$scope.minEndDate = new Date(workplan.start_date)
						$scope.maxEndDate = new Date(workplan.end_date)
						var colCounter = 1
						var colLimit = 4

						angular.forEach($scope.items, function (item, index) {
							if ((index + 1) % (colLimit + 1) == 0) {
								colCounter++
							}

							item.col = colCounter
						})

						$scope.toggle = (item, list) => {
							var idx = list.indexOf(item)

							if (idx > -1) {
								list.splice(idx, 1)
								$scope.submodules.splice(idx, 1)
							} else {
								list.push(item)
								$scope.submodules.push(item.id_code)
							}
						}

						$scope.exists = (item, list) => {
							return list.indexOf(item) > -1
						}

						$scope.isIndeterminate = () => {
							return ($scope.selected.length !== 0 && $scope.selected.length !== $scope.items.length)
						}

						$scope.isChecked = () => {
							return $scope.selected.length === $scope.items.length
						}

						$scope.toggleAll = () => {
							if ($scope.selected.length === $scope.items.length) {
								$scope.selected = []
								$scope.submodules = []
							} else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
								$scope.selected = $scope.items.slice(0)
								$scope.submodules = $scope.items.slice(0).map((option) => {
									return option.id_code
								})
							}
						}

						$scope.close = () => {
							$mdDialog.hide()
						}

						function aggregateToStatistic () {
							teacher.id_state = 2
							++specialSituationVM.specialSituations
							specialSituationVM.situationsPercentage = (Math.round((specialSituationVM.specialSituations / specialSituationVM.teachers.length) * 100)).toString()
						}

						$scope.addSituation = () => {
							let newSituation = {
								id_teacher                 : $scope.teacher.id_teacher,
								id_work_plan               : $scope.teacher.id_work_plan,
								ds_description             : $scope.details,
								dt_start_date              : moment(new Date($scope.startDate)).format('YYYY-MM-DD'),
								id_list_item_situation_type: $scope.situationData.id_lists_item,
								id_teacher_type            : $scope.teacher.id_teacher_type,
								id_submodule               : $scope.submodules.join(','),
								id_user                    : user.id,
							}

							$scope.addingEnabled = true

							if ($scope.isDisabled === true) {
								newSituation.dt_end_date = ''
							} else {
								newSituation.dt_end_date = moment(new Date($scope.endDate)).format('YYYY-MM-DD')
							}

							WorkPlanParametrizationSrv.addSpecialSituationTeacher
								.set(newSituation).$promise.then((dataReturn) => {
									if (dataReturn.status === true) {
										$scope.teacher.id_state = 2

										getSendNotifyAdmin(newSituation.id_teacher, GlobalConfig.notificationType.inbox)
										getSendNotifyAdmin(newSituation.id_teacher, GlobalConfig.notificationType.email)
										getSpecialSituationNotify($scope.teacher.teacher_userId, GlobalConfig.notificationType.email)
										getSpecialSituationNotify($scope.teacher.teacher_userId, GlobalConfig.notificationType.inbox)

										if (newSituation.dt_end_date !== '') {
											const dateToSend = moment(newSituation.dt_end_date).subtract(1, 'days').toDate()

											getSendNotifyRemainderAdmin(GlobalConfig.notificationType.inbox, dateToSend)
										}

										aggregateToStatistic()
										$mdDialog.hide()
										showSpecialSituationAdded(teacher)
									} else {
										console.log(dataReturn)
										$scope.addingEnabled = false
									}
								}).catch((error) => {
									console.log(error.data)
									$scope.addingEnabled = false
								})
						}
            
						function getSpecialSituationNotify(teacher_userId, notificationType) {
							const data = {
								idUser                      : teacher_userId,
								dsName                      : 'Notificación, situación especial',
								dsDescription               : ' Profesor, se le ha creado una situación especial. Debe comunicarse con su administrador para activar su plan de trabajo',
								idNotification_delivery_type: notificationType,
								is_grouped                  : 0,
							}

							GlobalSrv.sendNotification(data)
						}

						function getSendNotifyAdmin(teacherId, notificationType) {
							const data = {
								idTeacher                   : teacherId,
								dsName                      : 'Notificación, se agregó una situación especial',
								dsDescription               : 'Se ha creado una situación especial para el profesor ' + teacher.teacher_name,
								idNotification_delivery_type: notificationType,
								is_grouped                  : 0,
							}

							GlobalSrv.sendNotificationsToAdminEvaluator(data)
						}

						function getSendNotifyRemainderAdmin(notificationType, date) {
							const data = {
								rolesId                     : [ GlobalConfig.userRolesIds.workPlanAdmin ],
								dsName                      : 'Notificación, situación especial está por finalizar',
								dsDescription               : 'La situación especial del profesor "' + teacher.teacher_name + '" está por finalizar por lo que debe estar pendiente de la activación de su plan de trabajo',
								idNotification_delivery_type: notificationType,
								is_grouped                  : 1,
								sendDate                    : date,
							}

							GlobalSrv.addNotificationToAdminWorkPlan.add(data)
						}

						function validateForm(form) {
							return form.$invalid
						}

						function hasError(input) {
							if (typeof input !== 'undefined' && input.$invalid && (input.$dirty || input.$touched)) {
								return 'has-error'
							}
						}

						function showErrorMessages (input) {
							return input && (input.$dirty || input.$touched)
						}

						function startDateChange() {
							let m = moment($scope.startDate)

							$scope.minEndDate = m.isValid() ? m.add(1, 'days').toDate() : null
						}
					} ],
					template           : require('./addSituationModal.html'),
					clickOutsideToClose: true,
				})
			})
		}

		function showDetailsModal (teacher) {
			getTeachersDetails(teacher)
		}

		function showSpecialSituationAdded(teacher) {
			let infoAdded = teacher

			$mdDialog.show({
				controller: [ '$scope', '$mdDialog', function ($scope, $mdDialog) {
					$scope.infoAdded = infoAdded
					$scope.close = function () {
						$mdDialog.hide()
					}
				} ],
				template           : require('./specialSituationAddedModal.html'),
				clickOutsideToClose: true,
			})
		}

		// INITIALIZATION
		activate()
	}//FIN DEL CONSTRUCTOR
	preventInput(event) {
		var vKey = 86

		if (event.keyCode == vKey)
			event.preventDefault()

		return     
	}

}

SpecialSituationsCtrl.$inject = [ '$scope', 'WorkPlanParametrizationSrv', '$timeout', '$stateParams', '$mdDialog', '$interval', 'uiGridConstants', 'i18nService', 'GlobalSrv', 'GlobalConfig', '$cookies', 'Validations' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/workPlanParametrization/special/specialSituationsCtrl.js